import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import common translations
import commonTr from './locales/common/tr.json';
import commonEn from './locales/common/en.json';

// Import layout translations
import headerTr from './locales/layout/header/tr.json';
import headerEn from './locales/layout/header/en.json';
import sidebarTr from './locales/layout/sidebar/tr.json';
import sidebarEn from './locales/layout/sidebar/en.json';
import footerTr from './locales/layout/footer/tr.json';
import footerEn from './locales/layout/footer/en.json';

// Import page translations
import landingTr from './locales/pages/landing/tr.json';
import landingEn from './locales/pages/landing/en.json';
import blogTr from './locales/pages/blog/tr.json';
import blogEn from './locales/pages/blog/en.json';
import servicesTr from './locales/pages/services/tr.json';
import servicesEn from './locales/pages/services/en.json';
import dashboardTr from './locales/pages/dashboard/tr.json';
import dashboardEn from './locales/pages/dashboard/en.json';
import settingsTr from './locales/pages/settings/tr.json';
import settingsEn from './locales/pages/settings/en.json';
import checkoutTr from './locales/pages/checkout/tr.json';
import checkoutEn from './locales/pages/checkout/en.json';
import addCreditTr from './locales/pages/addCredit/tr.json';
import addCreditEn from './locales/pages/addCredit/en.json';

// Import old translation files as fallback (for backward compatibility)
import trTranslations from './locales/tr.json';
import enTranslations from './locales/en.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      tr: {
        common: commonTr,
        header: headerTr,
        sidebar: sidebarTr,
        footer: footerTr,
        landing: landingTr,
        blog: blogTr,
        services: servicesTr,
        dashboard: dashboardTr,
        settings: settingsTr,
        checkout: checkoutTr,
        addCredit: addCreditTr,
        // Fallback to old structure for backward compatibility
        translation: trTranslations,
      },
      en: {
        common: commonEn,
        header: headerEn,
        sidebar: sidebarEn,
        footer: footerEn,
        landing: landingEn,
        blog: blogEn,
        services: servicesEn,
        dashboard: dashboardEn,
        settings: settingsEn,
        checkout: checkoutEn,
        addCredit: addCreditEn,
        // Fallback to old structure for backward compatibility
        translation: enTranslations,
      },
    },
    fallbackLng: 'tr',
    defaultNS: 'translation',
    ns: ['common', 'header', 'sidebar', 'footer', 'landing', 'blog', 'services', 'dashboard', 'settings', 'checkout', 'addCredit', 'translation'],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['path', 'localStorage', 'navigator'],
      lookupFromPathIndex: 0,
      caches: ['localStorage'],
    },
  });

export default i18n;
